/**
 * Default footer disclaimer for the ClientWave360 agent webpage.
 * Surfaced in the intake form ("Reset to default") and used as the fallback
 * value when an agent has not set `profile.webpage_disclaimer`.
 */
export const DEFAULT_CF360_WEBPAGE_DISCLAIMER =
  '*We do not offer every plan available in your area. Any information provided is limited to those plans we do ' +
  'offer in your area. Please contact Medicare.gov or 1-800-MEDICARE to get information on all of your options. ' +
  'Not affiliated or endorsed by any government agency. Your information will be provided to a licensed insurance ' +
  'agent. You may be contacted by a licensed insurance agent.';

export const CF360_WEBPAGE_DISCLAIMER_MAX = 3000;
